






























import {Component, Vue, Watch} from 'vue-property-decorator';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';
import SlidingImageAndTextBlock from '@/components/Views/Home Page/SlidingImageAndTextBlock.vue';
import Footer from '@/components/Views/Home Page/Footer.vue';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';
import HeroExplainer from '@/components/Views/Home Page/HeroExplainer.vue';
import {Sync} from 'vuex-pathify';
import {nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import HeroImage2 from '@/components/Views/Home Page/HeroImage2.vue';
import LocationMixin from '@/mixins/LocationMixin.vue';
import WhiteListedLocationsDialog from "@/components/Pages/Booking Flow/WhiteListedLocationsDialog.vue";

@Component({
    components: {
        HeroImage2,
        HeroExplainer,
        FooterLinks,
        Footer,
        SlidingImageAndTextBlock,
        HeroImage,
        WhiteListedLocationsDialog

    },
})
export default class Home extends Mixins(ScreenSizeMixin, LocationMixin) {
    @Sync('auth/user') public user!: any;
    public heroImage = '/img/pages/home-hero.jpeg';
    public lazyHeroImage = '';
    public locationUnsupportedDialogOpen = false;
    private blocks = [
        {
            contain: true,
            image: '../img/pages/home1.jpg',
            header: 'THE ULTIMATE HAIR & MAKEUP STYLISTS AT YOUR FINGERTIPS',
            text: '<p>SoPlush Beauty Pros make it easier for you by coming to your house or other venue to give you what you want when you want it, at the place that is the most convenient for you.</p><p>Whether you just need a hair stylist, a makeup artist or you require a complete makeover, we can bring professional services to your door.</p>',
            button: {
                path: '/services/hair-and-makeup-services',
                text: 'Learn More About Hair & Makeup Services',
            },
        },
        {
            contain: true,
            image: '../img/services/5cf1baa0c45cc623910df257.jpg',
            header: 'CELEBRITY STATUS HAIR STYLING JUST FOR YOU',
            text: '<p>Let’s face the truth; a lot of people simply don’t have the time or energy to go to the hairdresser for a new look. However, it isn’t as far out of your reach as you think.</p><p> Now try to imagine any look or hair style possible. No matter what you have in mind, our VIP or Plush pros will make sure you are fully satisfied. </p>',
            button: {
                path: '/services/hair-services',
                text: 'Learn More About Hair Services',
            },
        },
        {
            image: '../img/services/5cf1baa0c45cc623910df252.jpg',
            header: 'WE\'VE GOT ALL YOUR MAKEUP NEEDS COVERED',
            text: '<p>Doing makeup is an art that shouldn’t be taken lightly. It makes all the difference in how other people see you and how you present yourself.</p> <p>For this reason, SoPlush Beauty have made it possible for you to have a makeup artist come to practically any location of your choosing and get down to work.</p>',
            button: {
                path: '/services/makeup-services',
                text: 'Learn More About Makeup Services',
            },
        },
        {
            image: '../img/services/5cf1baa0c45cc623910df260.jpg',
            header: 'COMPREHENSIVE WEDDING & BRIDAL STYLE EXPERTS',
            text: '<p>Your wedding day is one of the most important days of your life. The SoPlush Beauty Pros help alleviate stress by bringing the salon experience to you, wherever you are! We recommend starting with a wedding trial which includes an in-depth consultation to find out your desired makeup and hair style.</p><p>We will be there for your engagement photos, bridal shower, bachelorette party, all the way to the wedding ceremony and even the wedding afterparty. The SoPlush Pros are experienced with any size bridal party including maid of honor, groomsmen, flower girls, and bridesmaids. We use high end cosmetics and professional hair styling products to assure your look lasts long after the “I do’s”.</p>',
            button: {
                path: '/services/weddings',
                text: 'Learn More About Wedding Services',
            },
        },
        {
            image: '../img/pages/home5.jpg',
            header: 'URGENT SPECIAL EVENT STYLING NEEDED? WE\'RE THERE!',
            text: '<p>We at SoPlush Beauty understand how important it is to look your best during a special event. Our mobile beauty team is here for all types of occasions such as, date night, red carpet events, prom, girl’s night out, corporate meetings, anniversary, video and photoshoots, birthdays and everyday glam.</p><p> Our SoPlush Pros are 5-star award winning hairstylists and makeup artists that are comfortable working with all skin and hair types. Whether you choose a bright bold makeup look, a natural airbrush application, an effortless hair style or beautiful beach waves, our Beauty Pros will bring your desired look to life! So, get ready for a luxurious experience in the comfort and privacy of your own location.</p>',
            button: {
                path: '/services/events',
                text: 'Learn More About Special Events Services',
            },
        },
    ];
    mounted(){
        this.$bus.$on('location_not_supported', (data) =>{
            console.log('locatio not supported')
            this.$refs.unsupportedLocationsDialog.open();
        });
        this.setupAddressInputs();
    }
    @Sync('booking/step') private bookingStep!: number;
    @Watch('formattedAddress')
    private onLocationChanged(value: string, oldValue: string) {
        if (!nil(value) && value !== '') {
            if (this.bookingStep < 2) {
                this.bookingStep = 2;
            }
            window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    actionField:{'step':1}
                }
            });
            this.$router.replace('/book');
        }
    }

    get userIsAdmin() {
        return (!nil(this.user) && ['admin'].indexOf(this.user.role) > -1);
    }
    public get heroCtaStyle() {
        let spacing = 20;
        let width = '580px;';
        if (this.isXS(null)) {
            spacing = 0;
            width = '80vw';
        } else if (this.isSM(null)) {
            spacing = 0;
            width = '70vw';
        } else if (this.isMD(null)) {
            spacing = 15;
            width = '50vw';
        }
        return `border-radius:5%;width:${width};margin:${spacing}px;padding:${spacing}px`;
        // return width:580px;margin:20px;padding:20px
    }
}
